module.exports = __webpack_public_path__ + "img/zhangxi.edda87ac.jpg";